export default __webpack_public_path__ + "media/images/logo_transparent_white-6a4411385124cecda3cf2cc7173fd567.svg";